import Notifications from '@kyvg/vue3-notification';
import { App } from 'vue';

export const setupNotifications = (app: App<Element>) => app.use(Notifications);
